import OrgMembersRoster from '@/modules/organization/OrgMembersRoster';
import { createFileRoute } from '@tanstack/react-router';

const OrganizationRosterContainer = () => {
  return <OrgMembersRoster />;
};

export const Route = createFileRoute('/_authenticated/_organization/organization/roster')({
  staticData: { title: 'Roster' },
  component: OrganizationRosterContainer,
});
